import React from 'react'
import {Link} from 'react-router-dom'
import erimg from '../../images/error-404.png'


const Error = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(
        <section className="error-404-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="content clearfix">
                            <div className="error">
                                <img src={erimg} alt=""/>
                            </div>
                            <div className="error-message">
                                <h3>Ojoj! Stránka nenájdená!</h3>
                                <p>Ľutujeme, ale nemôžeme nájsť požadovanú stránku. Môže to byť spôsobené tým, že ste nesprávne zadali webovú adresu.</p>
                                <Link onClick={ClickHandler} to="/home2" className="theme-btn"> Späť na úvod</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Error;